export default __webpack_public_path__ + "static/chat-icon-user1-c9593942a1cff854010203a727218893.png";